import React, { useEffect, useState } from 'react'
import TaskModel from './models/TaskModel';
import TitleDropdown from '../../shared/common-dropdown/TitleDropdown';
import ClientDropdown from '../../shared/common-dropdown/ClientDropdown';
import UsersDropdown from '../../shared/common-dropdown/UserDropdown';
import PriorityDropdown from '../../shared/common-dropdown/PriorityDropdown';
import StatusDropdown from '../../shared/common-dropdown/StatusDropdown';

function ViewTask(props) {
  const [getTaskData, setTaskData] = useState(new TaskModel());
  const companyDetails = <div className="col-lg-12 col-sm-6 col-12">
    <div className="card">
      <div className="card-header justify-content-between">
        <div className="card-title">Company Details</div>
      </div>
      <div className="card-body">
        <div className="table-responsive">
          <table className="table text-nowrap table-sm">
            <thead>
              <tr>
                <th scope="col">Company Type</th>
                <th scope="col">Company</th>
                <th scope="col">Ref. No</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{props.TaskData.ClientCompanyTypeName}</td>
                <td>{props.TaskData.ClientCompanyName}</td>
                <td>{props.TaskData.ReferenceNumber}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>;
  return (
    <>
      <div className="row">
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="input-blocks1 mb-3">
            <TitleDropdown
              modelName="TitleId"
              required={true}
              selectedValue={props.TaskData.TitleId}
              isDisable={true}
            />
          </div>
        </div>
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="input-blocks1 mb-3">
            <ClientDropdown
              modelName="ClientId"
              selectedValue={props.TaskData.ClientId}
              isDisable={true}
            />
          </div>
        </div>
        {props.TaskData.ClientCompanyName !== null ? companyDetails : ""}


        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <UsersDropdown
              modelName="AssignedToUserId"
              selectedValue={props.TaskData.AssignedToId}
              isDisable={true}
            />
          </div>
        </div>
        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <PriorityDropdown
              modelName="PriorityId"
              selectedValue={props.TaskData.PriorityId}
              isDisable={true}
            />
          </div>
        </div>
        <div className="col-lg-4 col-sm-4 col-12">
          <div className="input-blocks1 mb-3">
            <StatusDropdown
              modelName="StatusId"
              required={true}
              selectedValue={props.TaskData.StatusId}
              isDisable={true}
            />
          </div>
        </div>
        <div className="col-lg-12 col-sm-6 col-12">
          <div className="summer-description-box transfer mb-3">
            <label className="form-label">Description</label>
            <textarea
              className="form-control h-100"
              rows="2"
              name="Description"
              value={props.TaskData.Description}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default ViewTask